import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTextItalic = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m17.613 8-5.334 16H8a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2h-3.613l5.334-16H24a1 1 0 1 0 0-2H14a1 1 0 1 0 0 2h3.613Z",
		fill: "currentColor"
	})
});
export default SvgTextItalic;
